export default __webpack_public_path__ + "static/media/TL10.0c360932.mp3";